import script from "./CoveredCallDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CoveredCallDetails.vue?vue&type=script&setup=true&lang=js"

import "./CoveredCallDetails.vue?vue&type=style&index=0&id=ada13cfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ada13cfc"]])

export default __exports__